import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getData } from "../../api";
import nextIcon from '../../images/next.png';
import { Mixpanel } from "../../mixpanel";
import Header from "../header/header";
import './identify.scss';

interface IdentifyProps {
    type?: 'pension' | 'insurance';
}

const Identify = ({ type = 'pension' }: IdentifyProps) => {
    Mixpanel.track( 'Page view',{page: `identify-${type}`});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [idNumber, setIdNumber] = useState("");
    const [apiError, setApiError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    let {token} = useParams();

    const onChange = (e: any) => {
        let value = e.target.value;
        if (value.length > 9)
            value = value.substring(0, 9);

        setIdNumber(value);
    }

    useEffect(() => {
        const idNumber = localStorage.getItem("idNumber");
        if (idNumber)
            setIdNumber(idNumber);
    }, [])

    const submit = async () => {
        if (isLoading)
            return;

        setApiError(false);
        setIsLoading(true);
        try {
            const result = await getData(idNumber, token || '', type);
            localStorage.setItem("idNumber", idNumber);
            localStorage.setItem("token", token || '');
            Mixpanel.track( 'submit ID clicked',{success: true, type});
            const queryString = searchParams.toString();
            const basePath = type === 'insurance' ? '/insurance' : '/pension';
            const path = queryString ? `${basePath}?${queryString}` : basePath;
            navigate(path, {state: result});
        } catch (err) {
            console.log(err);
            setApiError(true);
            Mixpanel.track( 'submit ID clicked',{success: false, type});
        } finally {
            setIsLoading(false);
        }
    }

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            submit();
        }
    };

    return (
        <div className="identify">
            <div className="wrapper">
                <Header/>
                <div className="content">

                    <div className="hi-user">היי!</div>
                    <div className="texts">
                        <div className="text2">

                            <b>{type === 'insurance' ? 'סיכום השיחה על ביטוחים מחכה לך כאן.' : 'סיכום השיחה הפנסיונית מחכה לך כאן.'}</b><br/>
                            אנא הזינו את תעודת הזהות
                        </div>
                    </div>

                    <div className="input">
                        {apiError && <div className="error">
                            <b>מספר הזהות לא מתאים</b>
                        </div>}
                        <input
                            className={apiError ? 'error' : ''}
                            type="tel"
                            max={999999999}
                            placeholder="תעודת זהות"
                            value={idNumber}
                            onChange={onChange}
                            onKeyDown={handleKeyDown}
                        />
                        <span className="button-wrapper" onClick={submit}>
                            <img src={nextIcon}/>
                        </span>
                    </div>
                </div>
            </div>
            {/*<div className="buttons">*/}
            {/*    <button className="approve-button" onClick={submit}>המשך</button>*/}
            {/*</div>*/}
        </div>
    );
}

export default Identify;
